var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { autoinject, transient } from 'aurelia-dependency-injection';
import { PLATFORM } from 'aurelia-pal';
import { Router } from 'aurelia-router';
import { I18N } from 'aurelia-i18n';
import * as Enumerable from 'linq';
import { BaseLottery } from '../../templates/base-lottery';
import { TokenClient } from '../../../../services/authentication/token-client.service';
import { NotificationClientService } from '../../../../services/basics/notification-client.service';
import { ClientHotLotteriesClientService } from '../../../../services/modules/client/client-hot-lotteries-client.service';
import { ClientLotteryClientService } from '../../../../services/modules/client/client-lottery-client-service';
import { DialogClientService } from '../../../../services/basics/dialog-client.service';
var RenderLotterySectioned = /** @class */ (function (_super) {
    __extends(RenderLotterySectioned, _super);
    function RenderLotterySectioned(lotteryClientService, router, tokenClientService, notificationClientService, i18N, hotLotteryClientService, dialogClientService) {
        var _this = _super.call(this, lotteryClientService, router, tokenClientService, notificationClientService, i18N, hotLotteryClientService, dialogClientService) || this;
        _this.sections = [];
        return _this;
    }
    RenderLotterySectioned_1 = RenderLotterySectioned;
    RenderLotterySectioned.prototype.activate = function (params) {
        this.loadSections();
        return _super.prototype.activate.call(this, params);
    };
    RenderLotterySectioned.prototype.loadSections = function () {
        var _this = this;
        try {
            var server = window.server;
            var layout = server && server.renderLayout ? server.renderLayout : null;
            var lottery = layout && layout.lottery ? layout.lottery : null;
            if (lottery && lottery.length) {
                this.sections = lottery
                    .filter(function (s) { return s.visible !== false; })
                    .map(function (s) { return _this.prepareRow(s); })
                    .filter(function (s) { return _this.isRow(s) ? s.children.length > 0 : !!_this.blockModule(s); })
                    .sort(function (a, b) { return (a.order || 0) - (b.order || 0); });
            }
        }
        catch (_a) {
            this.sections = [];
        }
    };
    RenderLotterySectioned.prototype.isRow = function (section) {
        return !!section && section.type === 'Row';
    };
    RenderLotterySectioned.prototype.prepareRow = function (section) {
        var _this = this;
        if (this.isRow(section)) {
            section.children = (section.children || []).filter(function (c) { return c.visible !== false && !!_this.blockModule(c); });
        }
        return section;
    };
    Object.defineProperty(RenderLotterySectioned.prototype, "shell", {
        get: function () {
            return this;
        },
        enumerable: false,
        configurable: true
    });
    RenderLotterySectioned.prototype.blockModule = function (section) {
        if (!section) {
            return null;
        }
        var variant = section.variant || RenderLotterySectioned_1.defaultVariantForType[section.type];
        return variant ? RenderLotterySectioned_1.variantModules[variant] : null;
    };
    // Lottery adverts/images are keyed by the lottery key (`<key>-image-…`), so prepend it.
    RenderLotterySectioned.prototype.getAdImage = function (props) {
        var size = this.size;
        if (props && props.image && props.image[size]) {
            return props.image[size];
        }
        if (props && props.imageKey) {
            return this.i18n.tr(this.key + '-' + props.imageKey + '-' + size);
        }
        return '';
    };
    RenderLotterySectioned.prototype.getAdLink = function (props, element) {
        if (props && props.link) {
            return this.resolveAdUrl(props.link, element);
        }
        if (props && props.linkKey) {
            return this.getAd(this.key + '-' + props.linkKey + '-' + this.size, element);
        }
        return '';
    };
    RenderLotterySectioned.prototype.refreshDraws = function () {
        this.sendHeightToClient(this.lastKnownHeight + "px", true);
        if (this.chooseTickets)
            this.chooseTickets.updateTicketNumbers();
    };
    RenderLotterySectioned.prototype.closeEditDialog = function () {
        this.ticketInEdit = null;
        this.sendHeightToClient(this.lastKnownHeight + "px", true);
    };
    Object.defineProperty(RenderLotterySectioned.prototype, "subscription", {
        get: function () {
            if (this.chooseTickets && this.chooseTickets.discountOffers) {
                return Enumerable.from(this.chooseTickets.discountOffers).lastOrDefault(function (x) { return x.isMonthlySubscription; });
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    RenderLotterySectioned.prototype.slide = function (ele, arrow) {
        $(ele).slideToggle();
        $(arrow).toggleClass("is-open");
    };
    var RenderLotterySectioned_1;
    RenderLotterySectioned.variantModules = {
        'lottery-lotteries-carousel-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-lotteries-carousel/lottery-lotteries-carousel'),
        'lottery-switch-pages-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-switch-pages/lottery-switch-pages'),
        'lottery-subscription-banner-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-subscription-banner/lottery-subscription-banner'),
        'lottery-choose-tickets-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-choose-tickets/lottery-choose-tickets'),
        'lottery-choose-tickets-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-choose-tickets-t3/lottery-choose-tickets-t3'),
        'lottery-game-information-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-game-information/lottery-game-information'),
        'lottery-game-information-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-game-information-t3/lottery-game-information-t3'),
        'lottery-banner-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-banner/lottery-banner'),
        'lottery-prize-breakdown-t3': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-prize-breakdown-t3/lottery-prize-breakdown-t3'),
        'hottest-lotteries-lottery': PLATFORM.moduleName('app/styles/client/render-engine/blocks/lottery-hottest-lotteries/lottery-hottest-lotteries'),
        'advert-t7': PLATFORM.moduleName('app/styles/client/render-engine/blocks/advert/advert'),
    };
    RenderLotterySectioned.defaultVariantForType = {
        LotteryLotteriesCarousel: 'lottery-lotteries-carousel-t7',
        LotterySwitchPages: 'lottery-switch-pages-t7',
        LotterySubscriptionBanner: 'lottery-subscription-banner-t7',
        LotteryChooseTickets: 'lottery-choose-tickets-t7',
        LotteryGameInformation: 'lottery-game-information-t7',
        LotteryBanner: 'lottery-banner-t3',
        LotteryPrizeBreakdown: 'lottery-prize-breakdown-t3',
        HottestLotteries: 'hottest-lotteries-lottery',
        Advert: 'advert-t7',
    };
    RenderLotterySectioned = RenderLotterySectioned_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [ClientLotteryClientService, Router,
            TokenClient, NotificationClientService,
            I18N, ClientHotLotteriesClientService, DialogClientService])
    ], RenderLotterySectioned);
    return RenderLotterySectioned;
}(BaseLottery));
export { RenderLotterySectioned };
